/** @file Assets panel registration: images and attachments with the Delete binding. */
import type { PanelEntry } from '../panelEntry';
import { AssetsPanel } from './AssetsPanel';
import { bindings } from './bindings';

/** Docked with the Hierarchy by default. */
export const panel: PanelEntry = { id: 'assets', title: 'panels.assets.title', bindings, component: AssetsPanel };
